export default __webpack_public_path__ + "static/media/banner3.f98bd19b.png";